<script setup lang="ts">
const { seller } = useSeller('server')
const t2 = useT2({
  homeTitle: {
    en: 'Linen Clothing, Bedding & Fabrics from Lithuania',
    lt: 'Lininiai drabužiai, patalynė ir audiniai iš Lietuvos',
  },
})

useHead({
  title: () => ts(t2('homeTitle')),
})

if (import.meta.server) {
  const contactBase = {
    '@type': 'ContactPoint',
    contactType: 'Customer Service',
    areaServed: ['LT', 'EU'],
    availableLanguage: ['English', 'Lithuanian'],
  }

  const orgAddress = {
    '@type': 'PostalAddress',
    streetAddress: 'S. Kerbedžio g. 23',
    addressLocality: 'Panevėžys',
    addressRegion: 'Panevėžio m. sav',
    postalCode: 'LT-35113',
    addressCountry: 'LT',
  }

  useHead({
    script: () => {
      const seo = seoSchema([
        {
          ...schemaOrgStub(),
          legalName: 'UAB LINAS LT',
          email: 'linenbylinas@linas.lt',
          telephone: '+37065800102',
          foundingDate: '1957-02-11',
          vatID: 'LT100004113316',
          numberOfEmployees: { '@type': 'QuantitativeValue', value: 250 },
          address: orgAddress,
          contactPoint: [
            { ...contactBase, telephone: '+37065800102' },
            { ...contactBase, telephone: '+37065800174' },
          ],
          location: {
            '@type': 'Place',
            name: 'UAB LINAS LT',
            address: orgAddress,
            geo: { '@type': 'GeoCoordinates', latitude: '55.742520', longitude: '24.380810' },
          },
          sameAs: ['https://www.instagram.com/linenbylinas/', 'https://www.facebook.com/linenbylinas', 'https://linas.lt'],
          hasMerchantReturnPolicy: {
            '@type': 'MerchantReturnPolicy',
            '@id': seoReturnPolicyId,
            returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
            merchantReturnDays: 14,
            returnMethod: ['https://schema.org/ReturnByMail', 'https://schema.org/ReturnInStore'],
            returnFees: 'https://schema.org/ReturnFeesCustomerResponsibility',
            refundType: 'https://schema.org/FullRefund',
            returnPolicyCountry: 'LT',
            merchantReturnLink: `${SEO_URL}/info/returns`,
            applicableCountry: SEO_RETURN_COUNTRIES,
          },
          hasShippingService: {
            '@type': 'ShippingService',
            '@id': seoShippingLtId,
            name: 'DPD pristatymas Lietuvoje',
            fulfillmentType: 'FulfillmentTypeDelivery',
            handlingTime: {
              '@type': 'ServicePeriod',
              duration: { '@type': 'QuantitativeValue', minValue: 0, maxValue: 2, unitCode: 'DAY' }, // TODO: real DPD numbers
              businessDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            },
            shippingConditions: {
              '@type': 'ShippingConditions',
              shippingOrigin: { '@type': 'DefinedRegion', addressCountry: 'LT' },
              shippingDestination: { '@type': 'DefinedRegion', addressCountry: 'LT' },
              shippingRate: { '@type': 'MonetaryAmount', value: 3.5, currency: 'EUR' },
              transitTime: {
                '@type': 'ServicePeriod',
                duration: { '@type': 'QuantitativeValue', minValue: 1, maxValue: 3, unitCode: 'DAY' }, // TODO: real DPD numbers
                businessDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
              },
            },
          },
        },
      ])
      return seo ? [seo] : []
    },
  })
}
</script>

<template>
  <DocumentUi :document-id="seller?.doc?.homepage?._id" />
</template>
